import EventPayment from 'domains/models/event_payment';
import EventPaymentLineItem from 'domains/models/event_payment_line_item';
import { Currency } from 'domains/models/service_price/currency';
import { EventTypeServiceListItem } from '../event_type_service';
import { z } from 'zod';
import { CurrencyEnum } from '../service_price/enum';
import { TaxInclusiveEnum } from '../tax_rate/enum';
import TaxRate from 'domains/models/tax_rate';
import { PaymentMethodEnum } from './enum';

const schemaEventPaymentLineItem = z.object({
  serviceId: z.number(),
  name: z.string(),
  unitAmount: z.number(),
  taxAmount: z.number(),
  taxInclusive: TaxInclusiveEnum.nullable(),
  isShowPrice: z.boolean(),
});

export type EventPaymentItem = z.infer<typeof schemaEventPaymentItem>;
export const schemaEventPaymentItem = z.object({
  paymentMethod: PaymentMethodEnum,
  stripePaymentIntentId: z.string().nullable(),
  receiptUrl: z.string().nullable(),
  totalAmount: z.number(),
  currency: CurrencyEnum.nullable(),
  items: z.array(schemaEventPaymentLineItem),
});

export type EventPaymentListItem = z.infer<typeof schemaEventPaymentListItem>;
export const schemaEventPaymentListItem = z.object({
  paymentMethod: PaymentMethodEnum,
  stripePaymentIntentId: z.string().nullable(),
  receiptUrl: z.string().nullable(),
  totalAmount: z.number(),
  currency: CurrencyEnum.nullable(),
  items: z.array(schemaEventPaymentLineItem),
});

export type EventPaymentCreateBody = z.infer<
  typeof schemaEventPaymentCreateBody
>;
export const schemaEventPaymentCreateBody = z.object({
  paymentMethod: PaymentMethodEnum,
  currency: CurrencyEnum.nullable(),
  items: z.array(
    z.object({
      serviceId: z.number(),
    }),
  ),
});
export const toItem = (eventPayment: EventPayment): EventPaymentItem => {
  let items = eventPayment.items;
  if (typeof items === 'string') {
    items = JSON.parse(items);
  }
  return {
    paymentMethod: eventPayment.paymentMethod,
    stripePaymentIntentId: eventPayment.stripePaymentIntentId,
    receiptUrl: eventPayment.receiptUrl,
    totalAmount: eventPayment.totalAmount,
    currency: eventPayment.currency,
    items,
  };
};

export const toListItem = (
  eventPayment: EventPayment,
): EventPaymentListItem => {
  let items = eventPayment.items;
  if (typeof items === 'string') {
    items = JSON.parse(items);
  }
  return {
    paymentMethod: eventPayment.paymentMethod,
    stripePaymentIntentId: eventPayment.stripePaymentIntentId,
    receiptUrl: eventPayment.receiptUrl,
    totalAmount: eventPayment.totalAmount,
    currency: eventPayment.currency,
    items,
  };
};

export const toLineItem = (
  item: EventTypeServiceListItem,
  currency: Currency,
): EventPaymentLineItem => {
  const price = item.isPaid ? item.price : 0;
  const isShowPrice = item.isShowPrice;
  const taxRate = new TaxRate({
    ...item,
  });
  const unitAmount = price ? price.unitAmount : 0;
  const taxInclusive = taxRate ? taxRate.taxInclusive : null;
  const taxAmount = EventPaymentLineItem.calcLineItemTaxAmount(
    unitAmount,
    taxRate,
    currency,
  );

  return {
    serviceId: item.serviceId!,
    name: item.name!,
    unitAmount,
    taxAmount,
    taxInclusive,
    isShowPrice,
  };
};
